document.addEventListener("DOMContentLoaded", function () {
  const searchButton = document.querySelector(".mobile-search-inner");
  const quickSearch = document.getElementById("MainQuickSearch");
  const quickSearchInput = quickSearch.querySelector(".quick-search__input");

  searchButton.addEventListener("click", function () {
    const isHidden = quickSearch.getAttribute("aria-hidden") === "true";
    quickSearch.setAttribute("aria-hidden", isHidden ? "false" : "true");

    if (isHidden) {
      quickSearch.classList.add("quick-search--visible");
      quickSearchInput.focus();
    } else {
      quickSearch.classList.remove("quick-search--visible");
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  var categoryOpenButton = document.querySelector(".category-open-button");
  var drawerMenu = document.querySelector(".drawer-menu");
  var headerMenuIcon = document.querySelector(".header__menu-icon");
  var bodyElement = document.querySelector("body");
  var haloStickyToolbarMobile = document.querySelector(
    ".halo-sticky-toolbar-mobile"
  );
  var quickCartWrapper = document.querySelector(".quick-cart__wrapper");
  if (
    categoryOpenButton &&
    drawerMenu &&
    headerMenuIcon &&
    bodyElement &&
    haloStickyToolbarMobile
  ) {
    categoryOpenButton.addEventListener("click", function () {
      // if (quickCartWrapper.classList.contains("active")) {
      //   quickCartWrapper.classList.remove("active");
      // }
      drawerMenu.classList.toggle("active");
      drawerMenu.classList.toggle("visible");
      drawerMenu.classList.toggle("animation--drawer-menu-revealed");
      if (headerMenuIcon.getAttribute("aria-expanded") === "true") {
        headerMenuIcon.setAttribute("aria-expanded", "false");
        headerMenuIcon.setAttribute("aria-label", "Open");
      } else {
        headerMenuIcon.setAttribute("aria-expanded", "true");
        headerMenuIcon.setAttribute("aria-label", "Close");
      }
      if (bodyElement.getAttribute("mobile-menu-open") === "true") {
        bodyElement.removeAttribute("mobile-menu-open");
      } else {
        bodyElement.setAttribute("mobile-menu-open", "true");
      }
      haloStickyToolbarMobile.classList.toggle("active");
    });
    headerMenuIcon.addEventListener("click", function () {
      if (drawerMenu.classList.contains("active")) {
        haloStickyToolbarMobile.classList.toggle("active");
      }
    });
  }
});

/* Ripple button Effect */
var button = document.querySelectorAll(".ripple-effect");
for (var i = 0; i < button.length; i++) {
  button[i].onmousedown = function (e) {
    var x = e.offsetX == undefined ? e.layerX : e.offsetX;
    var y = e.offsetY == undefined ? e.layerY : e.offsetY;
    var effect = document.createElement("div");
    effect.className = "effect";
    effect.style.top = y + "px";
    effect.style.left = x + "px";
    e.srcElement.appendChild(effect);
    setTimeout(function () {
      e.srcElement.removeChild(effect);
    }, 1100);
  };
}



document.addEventListener("DOMContentLoaded", function () {
  const colorSwatches = document.querySelectorAll(
    ".product__color-swatches .product__color-swatch"
  );
  colorSwatches.forEach((swatch) => {
    swatch.addEventListener("click", function () {
      const swipeAnimation2 = document.querySelector(".swipe-animation");
      if (swipeAnimation2) {
        swipeAnimation2.classList.remove("active");
      }
    });
  });
});

function runAnimations() {
  setTimeout(function () {
    document.querySelector("header.header ").style.opacity = "1";
  }, 200),
    setTimeout(function () {
      document.querySelector(".main").style.opacity = "1";
    }, 1000);
}

document.addEventListener("DOMContentLoaded", runAnimations),
  window.addEventListener("load", runAnimations);

const modal = document.getElementsByClassName("store-pickup-modal")[0];
const overlay = document.getElementsByClassName("pickup-mdal-overlay")[0];
const openModalBtn = document.getElementsByClassName("open-modal-btn")[0];
const closeCartBtn = document.getElementsByClassName(
  "quick-cart__close-icon"
)[0];
const closeModalBtn = document.getElementsByClassName("close-btn")[0];
const quickCartWrapper = document.getElementsByClassName("quick-cart__wrapper")[0];

// Event listener for the close button
closeModalBtn.addEventListener("click", function() {

 if (getComputedStyle(document.body).overflow === 'hidden') {
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
}

  // Optionally hide the quick cart wrapper if needed
  quickCartWrapper.classList.remove("active");
});

function openModal(event) {
  event.preventDefault();
  modal.style.display = "block";
  overlay.style.display = "block";
  quickCartWrapper.classList.remove("active");
}

function closeModal() {
  modal.style.display = "none";
  overlay.style.display = "none";
}

openModalBtn.addEventListener("click", openModal);
closeModalBtn.addEventListener("click", closeModal);
closeCartBtn.addEventListener("click", closeModal);
overlay.addEventListener("click", closeModal);

document.querySelector('.cart-open-icon').addEventListener('click', function() {
    document.body.style.overflow = 'hidden';
});
 
 
/* Cart Data Readding to cart page */
document.addEventListener('DOMContentLoaded', function () {
  const itemsRaw = localStorage.getItem('gokwikUnselectedItems');

  if (!itemsRaw) {
    console.log('No gokwikUnselectedItems in localStorage');
    return;
  }

  let items;
  try {
    items = JSON.parse(itemsRaw);
  } catch (e) {
    console.error('Invalid gokwikUnselectedItems JSON:', e);
    return;
  }

  if (!Array.isArray(items) || items.length === 0) {
    console.log('gokwikUnselectedItems is empty');
    return;
  }

  // Step 2: Fetch the cart contents
  fetch('/cart.js')
    .then(res => res.json())
    .then(cart => {
      // Step 3: If cart is empty, add gokwikUnselectedItems
      if (cart.items.length === 0) {
        console.log('Cart is empty, adding items...');

        // Add all items in one batch call
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({ items })
        })
        .then(response => {
          if (!response.ok) throw new Error('Add to cart failed');
          return response.json();
        })
        .then(data => {
          console.log('Items added to cart:', data);
          // Optionally clear localStorage or redirect
          localStorage.removeItem('gokwikUnselectedItems');
          //location.href = '/cart';
          //document.dispatchEvent(new CustomEvent('cart:refresh'));
          location.reload();
        })
        .catch(error => {
          console.error('Error adding to cart:', error);
        });

      } 
    })
    .catch(error => {
      console.error('Error fetching cart:', error);
    });
});


 